import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as XLSX from 'xlsx';
import ModalEditarHora from './ModalEditarHora';

const MarcajesRRHH = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [respuesta, setRespuesta] = useState(null);
  const [jsonRecibido, setJsonRecibido] = useState(null);
  const [fechaSeleccionada, setFechaSeleccionada] = useState('');
  const [fechaSeleccionada2, setFechaSeleccionada2] = useState('');
  const [detallesAbiertos, setDetallesAbiertos] = useState({});

  const [filtroNombre, setFiltroNombre] = useState('');
  const [filtroCompania, setFiltroCompania] = useState('');
  const [filtroUnidad, setFiltroUnidad] = useState('');
  const [filtroPuesto, setFiltroPuesto] = useState('');
  const [filtroArea, setFiltroArea] = useState('');
  const [filtroCodigo, setFiltroCodigo] = useState('');
  const [filtroHorasNegativas, setFiltroHorasNegativas] = useState(false);
  const [minutosARestar, setMinutosARestar] = useState(0);
  const [minutosRealesAcumulados, setMinutosRealesAcumulados] = useState({});
  const [minutosDescontados, setMinutosDescontados] = useState({});
  const [restarMinutosFaltantes, setRestarMinutosFaltantes] = useState(false);

  const [seleccionados, setSeleccionados] = useState({});
  const [seleccionarTodos, setSeleccionarTodos] = useState(false);
  const [horasSeleccionadas, setHorasSeleccionadas] = useState({});

  const [showModal, setShowModal] = useState(false);
  const [horaEditando, setHoraEditando] = useState({
    codigo: '',
    index: 0,
    tipo: '',
    segmento: 1,
    horaActual: '',
    fecha: '',
  });

  const handleEditarHora = (codigo, index, segmento, tipo, horaActual, fecha) => {
    setHoraEditando({
      codigo,
      index,
      segmento,
      tipo,
      horaActual,
      fecha,
    });
    setShowModal(true);
  };

  const handleGuardarCambios = async (datosEditados) => {
    const { codigo, index, segmento, tipo, horaActual, fecha } = datosEditados;

    const datosRecibidos = {
      CodUsu: codigo,
      Segmento: segmento.toString(),
      Frecuencia: tipo,
      Fecha: fecha.replace(/-/g, ''),
      tiempo: horaActual,
    };

    const postData = {
      Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
      Ambiente: 'DESA',
      Dispositivo: {
        Marca: 'motorola',
        Modelo: 'moto g54 5G',
        Version: '14',
        McAdress: null,
        PowerStatus: '84%',
        WifiStatus: 'Conected to iphone de Mauricio',
        GPSStatus: 'ON',
        GPS: '-90.509232|14.5903641|0',
      },
      User: {
        Codigo: '',
        UserNickName: 'Pierril',
      },
      Metodo: {
        NombreMetodo: 'ActualizarMarcaEnSabana',
        Datos_Recibidos: JSON.stringify(datosRecibidos),
        datos_Generados: '',
      },
    };

    try {
      setLoading(true);
      const response = await fetch('https://appcorp.parma.com.gt/API/ReceptorDatos', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(postData),
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      await response.json();

      const nuevosDatos = { ...respuesta };
      const key = tipo === 'E' ? `HoraE${segmento}` : `HoraS${segmento}`;
      nuevosDatos[codigo][index][key] = horaActual;
      setRespuesta(nuevosDatos);

      alert('Hora actualizada correctamente');
    } catch (errorActualizar) {
      console.error('Error al actualizar la hora:', errorActualizar);
      alert('Error al actualizar la hora: ' + errorActualizar.message);
    } finally {
      setLoading(false);
      setShowModal(false);
    }
  };

  const calcularMinutosPorJornada = (codigo) => {
    if (!respuesta || !respuesta[codigo]) {
      return {
        totalGeneral: { reales: 0, descontados: 0 },
        porJornada1: [],
      };
    }

    const jornadas = {
      Diurna: { reales: 0, descontados: 0 },
      Mixta: { reales: 0, descontados: 0 },
    };

    respuesta[codigo].forEach((marcaje) => {
      if (!marcaje) return;

      const minutos = parseFloat(marcaje.Minutos_Faltantes) || 0;
      const jornada = marcaje.Jornada === 'Mixta' ? 'Mixta' : 'Diurna';

      if (minutos < 0) {
        jornadas[jornada].reales += minutos;
      }
    });

    Object.keys(jornadas).forEach((tipo) => {
      const absMinutos = Math.abs(jornadas[tipo].reales);

      if (absMinutos >= 2 && absMinutos < 32) {
        jornadas[tipo].descontados = -30;
      } else if (absMinutos >= 32) {
        const horas = Math.floor(absMinutos / 60);
        const minutosRestantes = absMinutos % 60;
        const mediasHorasExtra = Math.ceil(minutosRestantes / 30);
        jornadas[tipo].descontados = -((horas * 2) + mediasHorasExtra) * 30;
      }
    });

    const porJornada1 = Object.keys(jornadas).map((tipo) => ({
      tipo,
      reales: jornadas[tipo].reales,
      descontados: jornadas[tipo].descontados,
    }));

    return {
      totalGeneral: {
        reales: porJornada1.reduce((sum, jornada) => sum + jornada.reales, 0),
        descontados: porJornada1.reduce((sum, jornada) => sum + jornada.descontados, 0),
      },
      porJornada1,
    };
  };

  const calcularSumaHorasSeleccionadas = (codigo) => {
    if (!respuesta || !respuesta[codigo]) {
      return {
        diurnaSimple: '0.00',
        diurnaDoble: '0.00',
        mixtaSimple: '0.00',
        mixtaDoble: '0.00',
        minutosFaltantes: 0,
        leyendaDescuento: '',
      };
    }

    const { porJornada1 } = calcularMinutosPorJornada(codigo);

    const horasExtras = {
      Diurna: { simple: 0, doble: 0 },
      Mixta: { simple: 0, doble: 0 },
    };

    Object.keys(horasSeleccionadas).forEach((key) => {
      if (!horasSeleccionadas[key]) return;

      const [codigoEmpleado, index] = key.split('-');
      if (codigoEmpleado !== codigo || Number(index) >= respuesta[codigo].length) return;

      const marcaje = respuesta[codigo][index];
      const horas = parseFloat(parseFloat(marcaje.HorasExtra).toFixed(2)) || 0;
      const tipo = marcaje.Tipo_Hora_Extra?.toUpperCase();
      const jornada = marcaje.Jornada === 'Mixta' ? 'Mixta' : 'Diurna';

      if (tipo === 'SIMPLE') {
        horasExtras[jornada].simple = parseFloat((horasExtras[jornada].simple + horas).toFixed(2));
      } else if (tipo === 'DOBLE') {
        horasExtras[jornada].doble = parseFloat((horasExtras[jornada].doble + horas).toFixed(2));
      }
    });

    const horasExtrasFinal = {
      Diurna: { ...horasExtras.Diurna },
      Mixta: { ...horasExtras.Mixta },
    };
    const descuentosAplicados = [];

    if (restarMinutosFaltantes) {
      porJornada1.forEach((jornada) => {
        let horasFaltantes = parseFloat((Math.abs(jornada.descontados) / 60).toFixed(2));
        if (horasFaltantes <= 0) return;

        const otraJornada = jornada.tipo === 'Diurna' ? 'Mixta' : 'Diurna';
        const bolsasParaDescontar = [
          { jornada: jornada.tipo, tipo: 'simple' },
          { jornada: jornada.tipo, tipo: 'doble' },
          { jornada: otraJornada, tipo: 'simple' },
          { jornada: otraJornada, tipo: 'doble' },
        ];

        bolsasParaDescontar.forEach((bolsa) => {
          if (horasFaltantes <= 0) return;

          const horasDisponibles = horasExtrasFinal[bolsa.jornada][bolsa.tipo];
          if (horasDisponibles <= 0) return;

          const horasADescontar = Math.min(horasDisponibles, horasFaltantes);
          horasExtrasFinal[bolsa.jornada][bolsa.tipo] = parseFloat((horasDisponibles - horasADescontar).toFixed(2));
          horasFaltantes = parseFloat((horasFaltantes - horasADescontar).toFixed(2));

          if (horasADescontar > 0) {
            descuentosAplicados.push({
              jornadaFaltante: jornada.tipo,
              jornadaDescontada: bolsa.jornada,
              tipoHora: bolsa.tipo,
              horas: horasADescontar,
            });
          }
        });
      });
    }

    const leyendaDescuento = descuentosAplicados.length > 0
      ? descuentosAplicados
          .map((descuento) =>
            `Se está haciendo el descuento de ${descuento.horas.toFixed(2)} horas ${descuento.tipoHora} ${descuento.jornadaDescontada.toLowerCase()} porque en la jornada ${descuento.jornadaFaltante.toLowerCase()} no cumplió.`
          )
          .join(' ')
      : '';

    return {
      diurnaSimple: Math.max(0, horasExtrasFinal.Diurna.simple).toFixed(2),
      diurnaDoble: Math.max(0, horasExtrasFinal.Diurna.doble).toFixed(2),
      mixtaSimple: Math.max(0, horasExtrasFinal.Mixta.simple).toFixed(2),
      mixtaDoble: Math.max(0, horasExtrasFinal.Mixta.doble).toFixed(2),
      minutosFaltantes: porJornada1.reduce((sum, jornada) => sum + jornada.reales, 0),
      aplicadoDescuento: restarMinutosFaltantes,
      leyendaDescuento,
    };
  };

  const restarFaltantesDeHoras = (horasObj, minutosFaltantes) => {
    const horasFaltantes = minutosFaltantes / 60;

    const jornadas = Object.entries(horasObj)
      .filter(([_, horas]) => horas > 0)
      .sort((a, b) => b[1] - a[1]);

    if (jornadas.length === 0) return;

    let faltantesPorRestar = horasFaltantes;
    for (const [jornada, horas] of jornadas) {
      if (faltantesPorRestar <= 0) break;

      const aRestar = Math.min(horas, faltantesPorRestar);
      horasObj[jornada] -= aRestar;
      faltantesPorRestar -= aRestar;
    }
  };

  const formatHoras = (horasObj) => {
    return {
      diurnaSimple: horasObj.diurnaSimple.toFixed(2),
      diurnaDoble: horasObj.diurnaDoble.toFixed(2),
      mixtaSimple: horasObj.mixtaSimple.toFixed(2),
      mixtaDoble: horasObj.mixtaDoble.toFixed(2),
    };
  };

  const enviarDatos = async () => {
    setLoading(true);
    setError(null);
    setRespuesta(null);
    setJsonRecibido(null);

    if (!fechaSeleccionada) {
      setError('Por favor, selecciona una fecha.');
      setLoading(false);
      return;
    }

    const fechaFormateada = fechaSeleccionada.replace(/-/g, '');
    const fechaFormateada2 = fechaSeleccionada2.replace(/-/g, '');
    const datos = {
      Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
      Ambiente: 'DESA',
      Dispositivo: {
        Marca: 'SAMSUNG',
        Modelo: 'S22002B',
        Version: 'Android 18.125',
        McAdress: null,
        PowerStatus: '84%',
        WifiStatus: 'Conected to iphone de Mauricio',
        GPSStatus: 'ON',
        GPS: '321|-485|321',
      },
      Usr: {
        Codigo: '',
        UserNickName: 'pierril',
      },
      DatosMetodo: {
        NombreMetodo: 'ListaMarcasEmpleadosBiometrico',
        Datos_Recibidos: JSON.stringify({
          FechaIni: fechaFormateada,
          FechaFin: fechaFormateada2,
          CodEmp: filtroCodigo,
          Nombre: filtroNombre,
          Area: filtroArea,
          Unidad: filtroUnidad,
        }),
      },
    };

    const fetchDataUrl = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(
      JSON.stringify(datos)
    )}`;

    try {
      const response = await fetch(fetchDataUrl);
      const data = await response.json();
      setJsonRecibido(data);

      if (data.datos_Generados) {
        const datosGenerados = JSON.parse(data.datos_Generados);

        if (typeof datosGenerados.MARCAS === 'string') {
          datosGenerados.MARCAS = JSON.parse(datosGenerados.MARCAS);
        }

        const datosAgrupados = datosGenerados.MARCAS.reduce((acc, marcaje) => {
          const codigo = marcaje.exp_codigo_alternativo;
          if (!acc[codigo]) {
            acc[codigo] = [];
          }
          acc[codigo].push(marcaje);
          return acc;
        }, {});

        setRespuesta(datosAgrupados);
        setSeleccionados({});
        setHorasSeleccionadas({});
        setSeleccionarTodos(false);
      } else {
        setError('No se encontraron datos generados en la respuesta.');
      }
    } catch (errorConsulta) {
      console.error('Error al procesar la respuesta:', errorConsulta);
      setError('Error al procesar la respuesta de la API.');
    } finally {
      setLoading(false);
    }
  };

  const toggleDetalles = (codigo) => {
    setDetallesAbiertos((prev) => ({
      ...prev,
      [codigo]: !prev[codigo],
    }));
  };

  const tieneHorasNegativas = (codigo) => {
    return respuesta[codigo].some((marcaje) => {
      const horasExtras = parseFloat(marcaje.HorasExtra);
      return !isNaN(horasExtras) && horasExtras < 0;
    });
  };

  const filtrarDatos = (datos) => {
    return Object.keys(datos).filter((codigo) => {
      const empleado = datos[codigo][0];
      const cumpleFiltros =
        empleado.exp_apellidos_nombres.toLowerCase().includes(filtroNombre.toLowerCase()) &&
        empleado.cia_descripcion.toLowerCase().includes(filtroCompania.toLowerCase()) &&
        empleado.uni_descripcion.toLowerCase().includes(filtroUnidad.toLowerCase()) &&
        empleado.pue_nombre.toLowerCase().includes(filtroPuesto.toLowerCase()) &&
        empleado.arf_nombre.toLowerCase().includes(filtroArea.toLowerCase()) &&
        empleado.exp_codigo_alternativo.toLowerCase().includes(filtroCodigo.toLowerCase());

      if (filtroHorasNegativas) {
        return cumpleFiltros && tieneHorasNegativas(codigo);
      }

      return cumpleFiltros;
    });
  };

  const handleSeleccionar = (codigo) => {
    const estaSeleccionado = !seleccionados[codigo];
    setSeleccionados((prev) => ({
      ...prev,
      [codigo]: estaSeleccionado,
    }));

    const nuevasHorasSeleccionadas = { ...horasSeleccionadas };
    respuesta[codigo].forEach((_, index) => {
      nuevasHorasSeleccionadas[`${codigo}-${index}`] = estaSeleccionado;
    });
    setHorasSeleccionadas(nuevasHorasSeleccionadas);
  };

  const handleSeleccionarTodos = () => {
    const nuevosSeleccionados = {};
    const nuevasHorasSeleccionadas = { ...horasSeleccionadas };

    if (!seleccionarTodos) {
      Object.keys(respuesta).forEach((codigo) => {
        nuevosSeleccionados[codigo] = true;
        respuesta[codigo].forEach((_, index) => {
          nuevasHorasSeleccionadas[`${codigo}-${index}`] = true;
        });
      });
    } else {
      Object.keys(respuesta).forEach((codigo) => {
        nuevosSeleccionados[codigo] = false;
        respuesta[codigo].forEach((_, index) => {
          nuevasHorasSeleccionadas[`${codigo}-${index}`] = false;
        });
      });
    }

    setSeleccionados(nuevosSeleccionados);
    setHorasSeleccionadas(nuevasHorasSeleccionadas);
    setSeleccionarTodos(!seleccionarTodos);
  };

  const handleSeleccionarHora = (codigo, index) => {
    setHorasSeleccionadas((prev) => ({
      ...prev,
      [`${codigo}-${index}`]: !prev[`${codigo}-${index}`],
    }));
  };

  const procesarSeleccionados = () => {
    procesarHorasSeleccionadas();
  };

  const procesarTodos = () => {
    console.log('Procesando todos los elementos');
    procesarHorasSeleccionadas();
  };

  const procesarHorasSeleccionadas = async (horasAProcesar = horasSeleccionadas) => {
    if (!respuesta) {
      console.error('No hay datos de respuesta disponibles.');
      return;
    }

    const horasProcesar = Object.keys(horasAProcesar).filter((key) => horasAProcesar[key]);

    const horasMarcadas = horasProcesar
      .map((key) => {
        const [codigo, index] = key.split('-');

        if (!respuesta[codigo] || !Array.isArray(respuesta[codigo])) {
          console.error(`No se encontraron datos para el código ${codigo}`);
          return null;
        }

        if (Number(index) >= respuesta[codigo].length) {
          console.error(`Índice ${index} fuera de rango para el código ${codigo}`);
          return null;
        }

        return respuesta[codigo][index];
      })
      .filter(Boolean);

    if (horasMarcadas.length === 0) {
      console.error('No hay horas seleccionadas válidas para procesar.');
      return;
    }

    const horasPorEmpleado = horasMarcadas.reduce((acc, marcaje) => {
      const codigo = marcaje.exp_codigo_alternativo;
      if (!acc[codigo]) {
        acc[codigo] = {
          CodEmpleado: marcaje.exp_codigo,
          CodigoAlternativo: codigo,
          Nombre: marcaje.exp_apellidos_nombres,
          HORASEXTRAS: {
            HESD: 0,
            HESM: 0,
            HEDD: 0,
            HEDM: 0,
          },
        };
      }

      return acc;
    }, {});

    const datosRecibidos = {
      FechaIni: fechaSeleccionada.replace(/-/g, ''),
      FechaFin: fechaSeleccionada2.replace(/-/g, ''),
      Empleados: Object.values(horasPorEmpleado).map((empleado) => {
        const horasExtrasSeleccionadas = calcularSumaHorasSeleccionadas(empleado.CodigoAlternativo);
        return {
          CodEmpleado: empleado.CodEmpleado,
          CodigoAlternativo: empleado.CodigoAlternativo,
          Nombre: empleado.Nombre,
          HORASEXTRAS: [
            { HESD: horasExtrasSeleccionadas.diurnaSimple },
            { HESM: horasExtrasSeleccionadas.mixtaSimple },
            { HEDD: horasExtrasSeleccionadas.diurnaDoble },
            { HEDM: horasExtrasSeleccionadas.mixtaDoble },
          ],
        };
      }),
    };

    const postRequest = {
      Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
      Ambiente: 'DESA',
      Dispositivo: {
        Marca: 'SAMSUNG',
        Modelo: 'S22002B',
        Version: 'Android 18.125',
        McAdress: null,
        PowerStatus: '84%',
        WifiStatus: 'Conected to iphone de Mauricio',
        GPSStatus: 'ON',
        GPS: '321|-485|321',
      },
      User: {
        Codigo: '',
        UserNickName: 'pierril',
      },
      Metodo: {
        NombreMetodo: 'GeneracionHorasExtras',
        Datos_Recibidos: JSON.stringify(datosRecibidos),
        Datos_Generados: '',
      },
    };

    try {
      const response = await fetch('https://appcorp.parma.com.gt/API/ReceptorDatos', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(postRequest),
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      await response.json();
      alert('Horas extras procesadas correctamente.');
    } catch (errorProceso) {
      console.error('Error:', errorProceso);
      alert('Hubo un error al procesar las horas extras.');
    }
  };

  const calcularMinutosFaltantesAcumulados = (codigo) => {
    if (!respuesta || !respuesta[codigo]) return { reales: 0, descontados: 0 };

    let minutosReales = 0;

    respuesta[codigo].forEach((marcaje) => {
      const minutos = parseFloat(marcaje.Minutos_Faltantes);
      if (!isNaN(minutos) && minutos < 0) {
        minutosReales += minutos;
      }
    });

    let minutosADescontar = 0;
    const absMinutos = Math.abs(minutosReales);

    if (absMinutos >= 2 && absMinutos < 32) {
      minutosADescontar = -30;
    } else if (absMinutos >= 32) {
      const horas = Math.floor(absMinutos / 60);
      const minutosRestantes = absMinutos % 60;
      const mediasHorasExtra = Math.ceil(minutosRestantes / 30);
      minutosADescontar = -((horas * 2) + mediasHorasExtra) * 30;
    }

    return {
      reales: minutosReales,
      descontados: minutosADescontar,
    };
  };

  const calcularMinutosFaltantes = (codigo) => {
    if (!respuesta || !respuesta[codigo]) {
      return {
        totales: { reales: 0, descontados: 0 },
        porJornada: [],
      };
    }

    const minutosPorJornada = {};
    let minutosRealesTotales = 0;

    respuesta[codigo].forEach((marcaje) => {
      const minutos = parseFloat(marcaje.Minutos_Faltantes);
      if (!isNaN(minutos) && minutos < 0) {
        minutosRealesTotales += minutos;

        const jornadaKey = marcaje.Fecha;
        if (!minutosPorJornada[jornadaKey]) {
          minutosPorJornada[jornadaKey] = {
            fecha: marcaje.Fecha,
            jornada: marcaje.Jornada || 'No especificada',
            minutos: 0,
          };
        }
        minutosPorJornada[jornadaKey].minutos += minutos;
      }
    });

    let minutosADescontar = 0;
    const absMinutos = Math.abs(minutosRealesTotales);

    if (absMinutos >= 2 && absMinutos < 32) {
      minutosADescontar = -30;
    } else if (absMinutos >= 32) {
      const horas = Math.floor(absMinutos / 60);
      const minutosRestantes = absMinutos % 60;
      const mediasHorasExtra = Math.ceil(minutosRestantes / 30);
      minutosADescontar = -((horas * 2) + mediasHorasExtra) * 30;
    }

    return {
      totales: {
        reales: minutosRealesTotales,
        descontados: minutosADescontar,
      },
      porJornada: Object.values(minutosPorJornada),
    };
  };

  const calcularMinutosFaltantesYRestarHorasExtras = (codigo) => {
    let minutosFaltantesTotales = 0;

    respuesta[codigo].forEach((marcaje) => {
      const minutosFaltantes = parseFloat(marcaje.Minutos_Faltantes);
      if (!isNaN(minutosFaltantes)) {
        minutosFaltantesTotales += minutosFaltantes;
      }
    });

    const horasFaltantes = minutosFaltantesTotales / 60;
    const horasExtrasSeleccionadas = calcularSumaHorasSeleccionadas(codigo);

    const horasExtrasFinales = {
      diurnaSimple: Math.max(0, parseFloat(horasExtrasSeleccionadas.diurnaSimple) - Math.abs(horasFaltantes)),
      diurnaDoble: Math.max(0, parseFloat(horasExtrasSeleccionadas.diurnaDoble) - Math.abs(horasFaltantes)),
      mixtaSimple: Math.max(0, parseFloat(horasExtrasSeleccionadas.mixtaSimple) - Math.abs(horasFaltantes)),
      mixtaDoble: Math.max(0, parseFloat(horasExtrasSeleccionadas.mixtaDoble) - Math.abs(horasFaltantes)),
    };

    return horasExtrasFinales;
  };

  const obtenerSegmentosVisibles = (marcajes) => {
    return Array.from({ length: 14 }, (_, i) => {
      const eKey = `HoraE${i + 1}`;
      const sKey = `HoraS${i + 1}`;
      const tieneDatos = marcajes.some(
        (marcaje) =>
          (marcaje[eKey] && marcaje[eKey] !== '-') ||
          (marcaje[sKey] && marcaje[sKey] !== '-')
      );

      return i < 5 || tieneDatos ? i + 1 : null;
    }).filter(Boolean);
  };

  const construirFilasExcel = (codigos) => {
    return codigos.flatMap((codigo) => {
      const marcajes = respuesta?.[codigo] || [];
      const empleado = marcajes[0] || {};
      const segmentos = obtenerSegmentosVisibles(marcajes);
      const resumenHoras = calcularSumaHorasSeleccionadas(codigo);
      const minutos = calcularMinutosFaltantes(codigo);

      return marcajes.map((marcaje) => {
        const fila = {
          'Código Alternativo': empleado.exp_codigo_alternativo || '',
          'Código Empleado': empleado.exp_codigo || '',
          Nombre: empleado.exp_apellidos_nombres || '',
          Compañía: empleado.cia_descripcion || '',
          Unidad: empleado.uni_descripcion || '',
          Puesto: empleado.pue_nombre || '',
          Área: empleado.arf_nombre || '',
          Fecha: marcaje.Fecha || '',
          Jornada: marcaje.Jornada || '',
          Día: marcaje.Dia || '',
          'Tipo de Día': marcaje.TipoDia || '',
          'Tipo Hora Extra': marcaje.Tipo_Hora_Extra || '',
          Asueto: marcaje.Asueto || '',
          'Horas/Minutos': marcaje.Horas_Minutos || '',
          'Horas Extra': marcaje.HorasExtra || '',
          'Minutos Faltantes': marcaje.Minutos_Faltantes || '',
          Estado: marcaje.Estado || '',
          'Diurnas Simples Seleccionadas': resumenHoras.diurnaSimple,
          'Diurnas Dobles Seleccionadas': resumenHoras.diurnaDoble,
          'Mixtas Simples Seleccionadas': resumenHoras.mixtaSimple,
          'Mixtas Dobles Seleccionadas': resumenHoras.mixtaDoble,
          'Minutos Faltantes Acumulados': minutos.totales.reales,
          'Minutos a Descontar': minutos.totales.descontados,
          'Leyenda Descuento': resumenHoras.leyendaDescuento || '',
        };

        segmentos.forEach((segmento) => {
          fila[`Hora Entrada ${segmento}`] = marcaje[`HoraE${segmento}`] || '-';
          fila[`Hora Salida ${segmento}`] = marcaje[`HoraS${segmento}`] || '-';
        });

        return fila;
      });
    });
  };

  const exportarMarcajesExcel = (codigos, nombreArchivo) => {
    if (!respuesta) {
      alert('No hay marcajes para exportar.');
      return;
    }

    const filas = construirFilasExcel(codigos);

    if (filas.length === 0) {
      alert('No hay datos para exportar.');
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(filas);
    worksheet['!cols'] = Object.keys(filas[0]).map((key) => ({
      wch: Math.max(key.length + 2, 16),
    }));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Marcajes');

    const desde = fechaSeleccionada || 'desde';
    const hasta = fechaSeleccionada2 || 'hasta';
    XLSX.writeFile(workbook, `${nombreArchivo}_${desde}_${hasta}.xlsx`);
  };

  const exportarTodosExcel = () => {
    const codigosFiltrados = filtrarDatos(respuesta);
    exportarMarcajesExcel(codigosFiltrados, 'Marcajes_Todos');
  };

  const exportarEmpleadoExcel = (codigo) => {
    exportarMarcajesExcel([codigo], `Marcajes_${codigo}`);
  };

  useEffect(() => {
    if (!respuesta) return;

    const nuevosMinutosReales = {};
    const nuevosMinutosDescontados = {};

    Object.keys(respuesta).forEach((codigo) => {
      const calculo = calcularMinutosFaltantesAcumulados(codigo);
      nuevosMinutosReales[codigo] = calculo.reales;
      nuevosMinutosDescontados[codigo] = calculo.descontados;
    });

    setMinutosRealesAcumulados(nuevosMinutosReales);
    setMinutosDescontados(nuevosMinutosDescontados);
  }, [respuesta]);

  const renderBotonEditar = (codigo, index, segmento, tipo, hora, fecha) => {
    if (tipo === 'E' && hora === '-') {
      return null;
    }

    return (
      <button
        className="btn btn-sm btn-outline-primary ms-2"
        onClick={(e) => {
          e.stopPropagation();
          handleEditarHora(codigo, index, segmento, tipo, hora, fecha);
        }}
      >
        Editar
      </button>
    );
  };

  return (
    <div>
      <h2>Marcajes de RRHH</h2>

      <div className="row mb-3">
        <div className="col-md-6">
          <label htmlFor="fechaDesde" className="form-label">DESDE:</label>
          <input
            type="date"
            id="fechaDesde"
            className="form-control"
            value={fechaSeleccionada}
            onChange={(e) => setFechaSeleccionada(e.target.value)}
          />
        </div>
        <div className="col-md-6">
          <label htmlFor="fechaHasta" className="form-label">HASTA:</label>
          <input
            type="date"
            id="fechaHasta"
            className="form-control"
            value={fechaSeleccionada2}
            onChange={(e) => setFechaSeleccionada2(e.target.value)}
          />
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-md-2">
          <input
            type="text"
            className="form-control"
            placeholder="Filtrar por codigo"
            value={filtroCodigo}
            onChange={(e) => setFiltroCodigo(e.target.value)}
          />
        </div>
        <div className="col-md-2">
          <input
            type="text"
            className="form-control"
            placeholder="Filtrar por nombre"
            value={filtroNombre}
            onChange={(e) => setFiltroNombre(e.target.value)}
          />
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-md-2">
          <input
            type="text"
            className="form-control"
            placeholder="Filtrar por compañía"
            value={filtroCompania}
            onChange={(e) => setFiltroCompania(e.target.value)}
          />
        </div>
        <div className="col-md-2">
          <input
            type="text"
            className="form-control"
            placeholder="Filtrar por unidad"
            value={filtroUnidad}
            onChange={(e) => setFiltroUnidad(e.target.value)}
          />
        </div>
        <div className="col-md-2">
          <input
            type="text"
            className="form-control"
            placeholder="Filtrar por puesto"
            value={filtroPuesto}
            onChange={(e) => setFiltroPuesto(e.target.value)}
          />
        </div>
        <div className="col-md-2">
          <input
            type="text"
            className="form-control"
            placeholder="Filtrar por Area"
            value={filtroArea}
            onChange={(e) => setFiltroArea(e.target.value)}
          />
        </div>
      </div>

      <div className="mb-3">
        <button
          className="btn btn-secondary me-2"
          onClick={() => setFiltroHorasNegativas(!filtroHorasNegativas)}
        >
          {filtroHorasNegativas ? 'Mostrar Todos' : 'Mostrar Horas Negativas'}
        </button>
      </div>

      <div className="mb-3">
        <button
          className="btn btn-primary"
          onClick={enviarDatos}
          disabled={loading || !fechaSeleccionada}
        >
          {loading ? 'Cargando...' : 'Obtener Marcajes'}
        </button>
        {error && <p className="text-danger mt-2">{error}</p>}
      </div>

      <div className="mb-3">
        <button
          className="btn btn-secondary me-2"
          onClick={handleSeleccionarTodos}
          disabled={!respuesta}
        >
          {seleccionarTodos ? 'Deseleccionar Todos' : 'Seleccionar Todos'}
        </button>
        <button
          className="btn btn-success me-2"
          onClick={procesarSeleccionados}
          disabled={Object.keys(seleccionados).length === 0}
        >
          Procesar Seleccionados
        </button>
        <button
          className="btn btn-warning me-2"
          onClick={procesarTodos}
          disabled={!respuesta}
        >
          Procesar Todos
        </button>
        <button
          className="btn btn-outline-success"
          onClick={exportarTodosExcel}
          disabled={!respuesta}
        >
          Exportar Excel Todos
        </button>
      </div>

      {respuesta && (
        <div style={{ marginTop: '20px' }}>
          {filtrarDatos(respuesta).map((codigo) => {
            const empleado = respuesta[codigo][0];
            const sumaHorasSeleccionadas = calcularSumaHorasSeleccionadas(codigo);
            const minutosReales = minutosRealesAcumulados[codigo] || 0;
            const { totales, porJornada } = calcularMinutosFaltantes(codigo);
            const { porJornada1 = [] } = calcularMinutosPorJornada(codigo) || {};
            const segmentosVisibles = obtenerSegmentosVisibles(respuesta[codigo]);

            return (
              <div
                key={codigo}
                style={{
                  marginBottom: '20px',
                  border: '1px solid #ddd',
                  padding: '10px',
                }}
              >
                <div
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                  onClick={() => toggleDetalles(codigo)}
                >
                  <div>
                    <input
                      type="checkbox"
                      checked={!!seleccionados[codigo]}
                      onChange={() => handleSeleccionar(codigo)}
                      onClick={(e) => e.stopPropagation()}
                    />{' '}
                    <strong>Código Alternativo:</strong> {empleado.exp_codigo_alternativo} <br />
                    <strong>Nombre:</strong> {empleado.exp_apellidos_nombres} <br />
                    <strong>Compañía:</strong> {empleado.cia_descripcion} <br />
                    <strong>Unidad:</strong> {empleado.uni_descripcion} <br />
                    <strong>Puesto:</strong> {empleado.pue_nombre}<br />
                    <strong> Area:</strong> {empleado.arf_nombre}
                    <br />
                    <button
                      className="btn btn-sm btn-outline-success mt-2"
                      onClick={(e) => {
                        e.stopPropagation();
                        exportarEmpleadoExcel(codigo);
                      }}
                    >
                      Exportar Excel Empleado
                    </button>
                  </div>
                  <div>{detallesAbiertos[codigo] ? '▲' : '▼'}</div>
                </div>

                {detallesAbiertos[codigo] && (
                  <div style={{ marginTop: '10px', maxHeight: '400px', overflowY: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={thStyle}>Aprobar</th>
                          <th style={thStyle}>Fecha</th>
                          <th style={thStyle}>Jornada</th>
                          <th style={thStyle}>Dia</th>
                          <th style={thStyle}>Tipo de Dia</th>
                          <th style={thStyle}>Tipo Hora Extra</th>
                          <th style={thStyle}>Asueto</th>
                          <th style={thStyle}>Horas/Minutos</th>
                          <th style={thStyle}>Horas Extra</th>
                          <th style={thStyle}>Minutos Faltantes</th>
                          {segmentosVisibles.map((segmento) => (
                            <React.Fragment key={segmento}>
                              <th style={thStyle}>Hora Entrada {segmento}</th>
                              <th style={thStyle}>Hora Salida {segmento}</th>
                            </React.Fragment>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {respuesta[codigo].map((marcaje, index) => (
                          <tr
                            key={index}
                            style={{
                              backgroundColor:
                                marcaje.Estado === 'Procesado'
                                  ? '#90EE90'
                                  : index % 2 === 0
                                    ? '#f9f9f9'
                                    : '#fff',
                            }}
                          >
                            <td style={tdStyle}>
                              <input
                                type="checkbox"
                                checked={!!horasSeleccionadas[`${codigo}-${index}`]}
                                onChange={() => handleSeleccionarHora(codigo, index)}
                              />
                            </td>
                            <td style={tdStyle}>{marcaje.Fecha}</td>
                            <td style={tdStyle}>{marcaje.Jornada}</td>
                            <td style={tdStyle}>{marcaje.Dia}</td>
                            <td style={tdStyle}>{marcaje.TipoDia}</td>
                            <td style={tdStyle}>{marcaje.Tipo_Hora_Extra}</td>
                            <td style={tdStyle}>{marcaje.Asueto}</td>
                            <td style={tdStyle}>{marcaje.Horas_Minutos}</td>
                            <td style={tdStyle}>{marcaje.HorasExtra}</td>
                            <td style={tdStyle}>{marcaje.Minutos_Faltantes}</td>
                            {segmentosVisibles.map((segmento) => {
                              const eKey = `HoraE${segmento}`;
                              const sKey = `HoraS${segmento}`;

                              return (
                                <React.Fragment key={segmento}>
                                  <td style={tdStyle}>
                                    {marcaje[eKey] || '-'}
                                    {renderBotonEditar(codigo, index, segmento, 'E', marcaje[eKey], marcaje.Fecha)}
                                  </td>
                                  <td style={tdStyle}>
                                    {marcaje[sKey] || '-'}
                                    {renderBotonEditar(codigo, index, segmento, 'S', marcaje[sKey], marcaje.Fecha)}
                                  </td>
                                </React.Fragment>
                              );
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                <div style={{ marginTop: '10px' }}>
                  <strong>Minutos Faltantes Acumulados:</strong> {minutosReales.toFixed(2)} minutos
                </div>

                <div>
                  <label>
                    <input
                      type="checkbox"
                      checked={restarMinutosFaltantes}
                      onChange={() => setRestarMinutosFaltantes(!restarMinutosFaltantes)}
                    />{' '}
                    Restar minutos faltantes a las horas extras
                  </label>
                </div>

                <div style={{ marginTop: '10px' }}>
                  <strong>Horas Extras Seleccionadas:</strong> <br />
                  - Diurnas Simples: {sumaHorasSeleccionadas.diurnaSimple} <br />
                  - Diurnas Dobles: {sumaHorasSeleccionadas.diurnaDoble} <br />
                  - Mixtas Simples: {sumaHorasSeleccionadas.mixtaSimple} <br />
                  - Mixtas Dobles: {sumaHorasSeleccionadas.mixtaDoble} <br />
                  {sumaHorasSeleccionadas.leyendaDescuento && (
                    <div className="alert alert-warning mt-2 mb-0">
                      {sumaHorasSeleccionadas.leyendaDescuento}
                    </div>
                  )}
                </div>

                <div>
                  <h5>Resumen de minutos faltantes</h5>
                  <p>Total acumulado: {totales.reales} minutos</p>
                  <p>Minutos a descontar: {totales.descontados} minutos</p>

                  <h6>Detalle por jornada:</h6>
                  <ul>
                    {porJornada.map((jornada, index) => (
                      <li key={index}>
                        {jornada.fecha} - {jornada.jornada}: {jornada.minutos} minutos
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="mt-4">
                  <h5>Minutos faltantes por tipo de jornada</h5>
                  {porJornada1.map((jornada1, index) => (
                    <div key={`jornada-${index}`}>
                      <h6>{jornada1.tipo || 'Jornada'}</h6>
                      <p>Faltantes: {jornada1.reales ?? 0}</p>
                      <p>Descontar: {jornada1.descontados ?? 0}</p>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}

      <div className="mb-3">
        <button
          className="btn btn-info"
          onClick={() => procesarHorasSeleccionadas()}
          disabled={Object.keys(horasSeleccionadas).length === 0}
        >
          Procesar Horas Seleccionadas
        </button>
      </div>

      <ModalEditarHora
        show={showModal}
        handleClose={() => setShowModal(false)}
        horaEditando={horaEditando}
        handleSave={handleGuardarCambios}
      />
    </div>
  );
};

const thStyle = {
  border: '1px solid #ddd',
  padding: '8px',
  backgroundColor: '#f2f2f2',
};

const tdStyle = {
  border: '1px solid #ddd',
  padding: '8px',
};

export default MarcajesRRHH;
